module.exports = __webpack_public_path__ + "img/3_uk.619b3b42.svg";